import * as React from "react";
function SvgPictureInPicture(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M18 11h-8v6h8v-6zm4 8V4.98C22 3.88 21.1 3 20 3H4c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 .02H4V4.97h16v14.05z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgPictureInPicture);
export default ForwardRef;
